const getVenueBrandsState = (state) => state.venueBrands;

export default getVenueBrandsState;
